module.exports = __webpack_public_path__ + "static/media/bunker-outcomes.0b6171a5.png";